<template>
  <div class="home">
    <SalePaymentGroupList v-show="listView" @newPayment="onClickNewFromList" @editPayment="onClickEditFromList" :scroll="corY" :idx="idx" ref="refreshList"/>
    <SalePaymentGroupForm v-show="formView" :payment="payment" @backClicked="onBackChild" @backClickID="onBackChildID" @backSaveClicked="onBackSaveChild"/>
  </div>
</template>

<script>
// @ is an alias to /src
import SalePaymentGroupList from '@/components/payment/SalePaymentGroupList.vue'
import SalePaymentGroupForm from '@/components/payment/SalePaymentGroupForm.vue'
import { mapState } from 'vuex'
import Axios from 'axios'
import { getHeader, paymentUrl } from '../../config'

export default {
  name: 'SalesPaymentGroup',
  components: {
    SalePaymentGroupList,
    SalePaymentGroupForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      idx: null,
      payment: {
        id: null,
        group_no: null,
        prepayment_date: null,
        payment_date: null,
        finish_date: null,
        category: null,
        subtotal: '0',
        round: '0',
        penalty_amount: '0',
        discount: '0',
        discount_percentage: '0',
        total: '0',
        method_id: null,
        method: null,
        type_id: null,
        type: null,
        bank_id: null,
        bank: null,
        account_code: null,
        account: null,
        notes: null,
        vendor_no: null,
        vendor: null,
        customer_no: null,
        customer: null,
        branch_no: null,
        branch: null,
        company_no: null,
        company: null,
        status: null,
        lock: false,
        giro_no: null,
        bank_name: null,
        report_no: null,
        ref_no: null,
        finish: false,
        manual_journal: false,
        salesman_id: null,
        refs: [{
          group_no: null,
          total: 0
        }],
        sales: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null,
          group_no: null,
          account_code: null,
          account: null,
          finish: false
        }],
        saleData: [{
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          type_id: null,
          customer_no: null,
          customer: null,
          branch_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          price_id: null,
          warehouse_no: null,
          salesman_id: null,
          salesman: null,
          lock: false,
          company_no: null,
          company: null,
          term_due_id: null,
          print_counter: null,
          bstk_counter: null,
          outstanding: '0',
          level: null,
          method_id: null,
          method: null,
          account_code: null,
          payment_no: null,
          payment_date: null,
          group_no: null
        }]
      }
    }
  },
  methods: {
    onBackChildID: function (id) {
      Axios.get(paymentUrl + '/' + id + '?status=sales', { headers: getHeader() })
        .then(response => {
          this.onClickEditFromList(response.data.data)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(x + '|' + y)
      this.listView = false
      this.formView = true
      this.idx = value.index
      this.payment = value.data
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(x + '|' + y)
      this.listView = false
      this.formView = true
      this.payment = {
        id: null,
        group_no: null,
        prepayment_date: null,
        payment_date: new Date().toISOString(),
        finish_date: null,
        category: 'sales',
        subtotal: '0',
        round: '0',
        penalty_amount: '0',
        discount: '0',
        discount_percentage: '0',
        total: '0',
        method_id: null,
        method: null,
        type_id: null,
        type: null,
        bank_id: null,
        bank: null,
        account_code: null,
        account: null,
        notes: null,
        vendor_no: null,
        vendor: null,
        customer_no: null,
        customer: null,
        branch_no: this.authUser.branch_no,
        branch: null,
        company_no: this.authUser.company_no,
        company: null,
        status: null,
        lock: false,
        giro_no: null,
        bank_name: null,
        report_no: null,
        ref_no: null,
        finish: true,
        manual_journal: false,
        salesman_id: null,
        refs: [{
          group_no: null,
          total: 0
        }],
        sales: [],
        saleData: [{
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          type_id: null,
          customer_no: null,
          customer: null,
          branch_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          price_id: null,
          warehouse_no: null,
          salesman_id: null,
          salesman: null,
          lock: false,
          company_no: null,
          company: null,
          term_due_id: null,
          print_counter: null,
          bstk_counter: null,
          outstanding: '0',
          level: null,
          method_id: null,
          method: null,
          account_code: null,
          payment_no: null,
          payment_date: null,
          group_no: null
        }]
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.payment = {
        id: null,
        group_no: null,
        prepayment_date: null,
        payment_date: null,
        finish_date: null,
        category: null,
        subtotal: '0',
        round: '0',
        penalty_amount: '0',
        discount: '0',
        discount_percentage: '0',
        total: '0',
        method_id: null,
        method: null,
        type_id: null,
        type: null,
        bank_id: null,
        bank: null,
        account_code: null,
        account: null,
        notes: null,
        vendor_no: null,
        vendor: null,
        customer_no: null,
        customer: null,
        branch_no: null,
        branch: null,
        company_no: null,
        company: null,
        status: null,
        lock: false,
        giro_no: null,
        bank_name: null,
        report_no: null,
        ref_no: null,
        finish: false,
        manual_journal: false,
        salesman_id: null,
        refs: [{
          group_no: null,
          total: 0
        }],
        sales: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null,
          group_no: null,
          account_code: null,
          account: null,
          finish: false
        }],
        saleData: [{
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          type_id: null,
          customer_no: null,
          customer: null,
          branch_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          price_id: null,
          warehouse_no: null,
          salesman_id: null,
          salesman: null,
          lock: false,
          company_no: null,
          company: null,
          term_due_id: null,
          print_counter: null,
          bstk_counter: null,
          outstanding: '0',
          level: null,
          method_id: null,
          method: null,
          account_code: null,
          payment_no: null,
          payment_date: null,
          group_no: null
        }]
      }
      // this.$refs.refreshList.refreshListdd()
    },
    async onBackSaveChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.payment = {
        id: null,
        group_no: null,
        prepayment_date: null,
        payment_date: null,
        finish_date: null,
        category: null,
        subtotal: '0',
        round: '0',
        penalty_amount: '0',
        discount: '0',
        discount_percentage: '0',
        total: '0',
        method_id: null,
        method: null,
        type_id: null,
        type: null,
        bank_id: null,
        bank: null,
        account_code: null,
        account: null,
        notes: null,
        vendor_no: null,
        vendor: null,
        customer_no: null,
        customer: null,
        branch_no: null,
        branch: null,
        company_no: null,
        company: null,
        status: null,
        lock: false,
        giro_no: null,
        bank_name: null,
        report_no: null,
        ref_no: null,
        finish: false,
        manual_journal: false,
        salesman_id: null,
        refs: [{
          group_no: null,
          total: 0
        }],
        sales: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null,
          group_no: null,
          account_code: null,
          account: null,
          finish: false
        }],
        saleData: [{
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          type_id: null,
          customer_no: null,
          customer: null,
          branch_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          price_id: null,
          warehouse_no: null,
          salesman_id: null,
          salesman: null,
          lock: false,
          company_no: null,
          company: null,
          term_due_id: null,
          print_counter: null,
          bstk_counter: null,
          outstanding: '0',
          level: null,
          method_id: null,
          method: null,
          account_code: null,
          payment_no: null,
          payment_date: null,
          group_no: null
        }]
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  mounted () {
    this.$store.dispatch('getPaymentTypeList')
    this.$store.dispatch('getPaymentMethodList')
    this.$store.dispatch('getCustomerListLite')
    this.$store.dispatch('getChartOfAccountList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getBankList')
    this.$store.dispatch('getEmployeeList')
  }
}
</script>
